export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/service-provider/service-bookings', 'service-provider.service-bookings')
    .when('/service-provider/service-bookings/:id', 'service-provider.service-booking-info')
    .when('/service-provider/service-bookings/:id/book-additional-service', 'service-provider.book-additional-service')
    .when('/service-provider/service-bookings/:id/reporting', 'service-provider.service-booking-reporting')
    .when('/service-provider/service-bookings/:id/bicycles/:bicycleId', 'service-provider.bicycle-info')
    .when('/service-provider/service-bookings/:id/bicycle-owner/:ownerId', 'service-provider.bicycle-owner-info')
    .when('/service-provider/service-bookings/:id/organisation/:orgId', 'service-provider.organisation-info')

    .within('service-provider')

    .segment('book-additional-service', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [
        {
          label: 'service_provider.breadcrumb.service_bookings',
          url: '/service-provider/service-bookings'
        },
        {
          label: 'service_provider.breadcrumb.booking_info',
          url: '/service-provider/service-bookings/:id',
          params: {
            id: ':id'
          }
        },
        {
          label: 'service_provider.breadcrumb.book_additional_service'
        }
      ],
      template: '<service-provider-book-additional-service-page></service-provider-book-additional-service-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-book-additional-service.module" */ "./book-additional-service/service-provider-book-additional-service.module");
      }
    })

    .segment('service-bookings', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.service_bookings'
      }],
      template: '<service-provider-requests-list-page></service-provider-requests-list-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-requests-list.module" */ "./list/service-provider-requests-list.module");
      }
    })

    .segment('service-booking-info', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC', isRequest: true},
      breadcrumb: [
        {
          label: 'service_provider.breadcrumb.service_bookings',
          url: '/service-provider/service-bookings',
        },
        {
          label: 'service_provider.breadcrumb.booking_info'
        }
      ],
      template: '<service-provider-request-info-page></service-provider-request-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-request-info.module" */ "./info/service-provider-request-info.module");
      }
    })

    .segment('service-booking-reporting', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [
        {
          label: 'service_provider.breadcrumb.service_bookings',
          url: '/service-provider/service-bookings',
        },
        {
          label: 'service_provider.breadcrumb.booking_info',
          url: '/service-provider/service-bookings/:id',
          params: {
            id: ':id'
          }
        },
        {
          label: 'service_provider.breadcrumb.booking_reporting',
        }
      ],
      template: '<service-provider-request-reporting-page></service-provider-request-reporting-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-request-reporting.module" */ "./reporting/service-provider-request-reporting.module");
      }
    })

    .segment('bicycle-info', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [
        {
          label: 'service_provider.breadcrumb.service_bookings',
          url: '/service-provider/service-bookings'
        },
        {
          label: 'service_provider.breadcrumb.booking_info',
          url: '/service-provider/service-bookings/:id',
          params: {
            id: ':id'
          }
        },
        {
          label: 'service_provider.breadcrumb.bicycle',
        }
      ],
      template: '<service-provider-bicycle-info-page></service-provider-bicycle-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-bicycle-info.module" */ "./bicycle-info/service-provider-bicycle-info.module");
      }
    })

    .segment('bicycle-owner-info', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [
        {
          label: 'service_provider.breadcrumb.service_bookings',
          url: '/service-provider/service-bookings'
        },
        {
          label: 'service_provider.breadcrumb.booking_info',
          url: '/service-provider/service-bookings/:id',
          params: {
            id: ':id'
          }
        },
        {
          label: 'service_provider.breadcrumb.bicycle_owner',
        }
      ],
      template: '<service-provider-bicycle-owners-info-page></serviceProviderBicycleOwnersInfoPage>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-bicycle-owner-info.module" */ "./bicycle-owner-info/service-provider-bicycle-owner-info.module");
      }
    })

    .segment('organisation-info', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [
        {
          label: 'service_provider.breadcrumb.service_bookings',
          url: '/service-provider/service-bookings'
        },
        {
          label: 'service_provider.breadcrumb.booking_info',
          url: '/service-provider/service-bookings/:id',
          params: {
            id: ':id'
          }
        },
        {
          label: 'service_provider.breadcrumb.organisation',
        }
      ],
      template: '<service-provider-organisations-info-page></service-provider-organisations-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-organisation-info.module" */ "./organisation-info/service-provider-organisation-info.module");
      }
    })
}
